/**
 * SEO 配置 - models (Nederlands)
 */

export default {
    veo_3_1: {
        title: 'Google Veo 3.1 | WeryAI',
        description: 'Experience Google Veo 3.1 on WeryAI. High-quality results.',
        keywords: 'Google Veo 3.1, AI, WeryAI',
    },
    veo_3: {
        title: 'veo 3 | WeryAI',
        description: 'Experience veo 3 on WeryAI. High-quality results.',
        keywords: 'veo_3, AI, WeryAI',
    },
    veo_3_fast: {
        title: 'veo 3 fast | WeryAI',
        description: 'Experience veo 3 fast on WeryAI. High-quality results.',
        keywords: 'veo_3_fast, AI, WeryAI',
    },
    sora_2: {
        title: 'OpenAI Sora 2 | Fysica-nauwkeurige AI-videogenerator | WeryAI',
        description: "Genereer realistisch, fysica-nauwkeurige AI-video's met OpenAI Sora 2 met gesynchroniseerde audio en multi-shot consistentie.",
        keywords: 'Sora 2, OpenAI Sora, video model, realistische AI video, tekst naar video, WeryAI',
    },
    weryai_video_1: {
        title: 'WeryAI Video 1.0 | WeryAI',
        description: 'Experience WeryAI Video 1.0 on WeryAI.',
        keywords: 'WeryAI Video 1.0, AI, WeryAI',
    },
    weryai_image_2: {
        title: 'WeryAI Image 2.0 | WeryAI',
        description: 'Experience WeryAI Image 2.0 on WeryAI.',
        keywords: 'WeryAI Image 2.0, AI, WeryAI',
    },
    image_grok_2: {
        title: 'Grok-2 | xAI | WeryAI',
        description: 'Experience Grok-2 by xAI on WeryAI.',
        keywords: 'Grok-2, xAI, AI, WeryAI',
    },
    kling_ai: {
        title: 'Kling 2.5 Turbo | Cinematografische AI Videogenerator | WeryAI',
        description: `Kling 2.5 Turbo maakt hoogwaardige video's met geavanceerde lenscontrole, emotionele expressies en vloeiende fysica.`,
        keywords: 'Kling 2.5 Turbo, Kling AI, cinematografische AI video, lenscontrole AI, WeryAI',
    },
    runway_ai: {
        title: 'Runway Gen-4 - Geavanceerde AI-videogenerator en -bewerking | WeryAI',
        description: `Runway Gen-4 genereert realistische, consistente AI-video's met dieper promptbegrip en slimme bewerkingstools. Probeer het gratis op WeryAI.`,
        keywords: 'Runway Gen-4, Runway AI, AI-videogenerator, tekst naar video, afbeelding naar video, AI-videobewerking, WeryAI',
    },
    hailuo_23: {
        title: 'hailuo 23 | WeryAI',
        description: 'Experience hailuo 23 on WeryAI. High-quality results.',
        keywords: 'hailuo_23, AI, WeryAI',
    },
    hailuo_ai: {
        title: 'Hailuo AI Videogenerator - Geavanceerde Videocreatie | WeryAI',
        description: `Genereer geavanceerde AI video's met Hailuo AI op WeryAI. Voorzien van state-of-the-art bewegingscontrole en realistische rendering.`,
        keywords: 'Hailuo AI, MiniMax, AI videogenerator, bewegingscontrole, realistische video, WeryAI',
    },
    pika_2_2: {
        title: 'pika 2 2 | WeryAI',
        description: 'Experience pika 2 2 on WeryAI. High-quality results.',
        keywords: 'pika_2_2, AI, WeryAI',
    },
    seedance: {
        title: 'Seedance AI videogenerator - Dans en beweging creatie | WeryAI',
        description: 'Seedance AI videogenerator - Dans en beweging creatie on WeryAI. Realistic and professional results.',
        keywords: 'seedance, AI, WeryAI',
    },
    image_nano_banana_pro: {
        title: 'Nano Banana Pro - Google Gemini 3.0 Pro beeldgeneratie | WeryAI',
        description: 'Nano Banana Pro - Google Gemini 3.0 Pro beeldgeneratie on WeryAI. Fast and high-quality results.',
        keywords: 'nano_banana_pro, AI, WeryAI',
    },
    image_nano_banana: {
        title: 'Google Nano Banana - Gemini 2.5 Flash hoge snelheid tekenen | WeryAI',
        description: 'Google Nano Banana - Gemini 2.5 Flash hoge snelheid tekenen on WeryAI. Fast and high-quality results.',
        keywords: 'nano_banana, AI, WeryAI',
    },
    image_flux: {
        title: 'FLUX AI beeldgenerator - Top open source tekenmodel | WeryAI',
        description: 'FLUX AI beeldgenerator - Top open source tekenmodel on WeryAI. Fast and high-quality results.',
        keywords: 'flux, AI, WeryAI',
    },
    image_flux_kontext: {
        title: 'FLUX.1 Kontext - Professionele AI tekenverbetering | WeryAI',
        description: 'FLUX.1 Kontext - Professionele AI tekenverbetering on WeryAI. Fast and high-quality results.',
        keywords: 'flux_kontext, AI, WeryAI',
    },
    image_imagen: {
        title: 'Google Imagen 4 - Geavanceerd tekst-naar-beeld diffusiemeodel van Google | WeryAI',
        description: 'Google Imagen 4 - Geavanceerd tekst-naar-beeld diffusiemeodel van Google on WeryAI. Fast and high-quality results.',
        keywords: 'imagen, AI, WeryAI',
    },
    image_qwen_image: {
        title: 'Qwen Image - Open source tekst renderingsmodel van Alibaba | WeryAI',
        description: 'Qwen Image - Open source tekst renderingsmodel van Alibaba on WeryAI. Fast and high-quality results.',
        keywords: 'qwen_image, AI, WeryAI',
    },
    image_wan_ai: {
        title: 'Wan 2.5 beeldgeneratie - High fidelity beeldmodel van Alibaba | WeryAI',
        description: 'Wan 2.5 beeldgeneratie - High fidelity beeldmodel van Alibaba on WeryAI. Fast and high-quality results.',
        keywords: 'wan_ai, AI, WeryAI',
    },
    image_seendream: {
        title: 'Seedream 4.0 - ByteDance batch 4K tekenmodel | WeryAI',
        description: 'Seedream 4.0 - ByteDance batch 4K tekenmodel on WeryAI. Fast and high-quality results.',
        keywords: 'seendream, AI, WeryAI',
    },
    image_dreamina: {
        title: 'Dreamina 4.0 - ByteDance alles-in-één AI beeldcreatiemodel | WeryAI',
        description: 'Dreamina 4.0 - ByteDance alles-in-één AI beeldcreatiemodel on WeryAI. Fast and high-quality results.',
        keywords: 'dreamina, AI, WeryAI',
    },
    image_seedream_4_5: {
        title: 'Seedream 4.5 - ByteDance Vlaggenschip AI Beeldgeneratiemodel | WeryAI',
        description: 'Seedream 4.5 is ByteDances nieuwste vlaggenschip AI-beeldmodel met focus op nauwkeurige typografie-rendering en multi-beeld fusie met 4K ultra HD output. Probeer gratis op WeryAI.',
        keywords: 'Seedream 4.5, AI beeldgeneratie, typografie-rendering, beeldfusie, ByteDance, 4K kwaliteit, WeryAI',
    },
    image_midjourney: {
        title: 'Midjourney - Top artistieke esthetiek AI tekenen | WeryAI',
        description: 'Midjourney - Top artistieke esthetiek AI tekenen on WeryAI. Fast and high-quality results.',
        keywords: 'midjourney, AI, WeryAI',
    },
    runway_4_5: {
        title: 'Runway Gen-4.5 AI Video Generator - Maak Filmische Video\'s | WeryAI',
        description: 'Maak verbluffende video\'s met Runway Gen-4.5 op WeryAI. Hybride autoregressief-diffusie architectuur voor nauwkeurige fysica simulatie en temporele consistentie.',
        keywords: 'Runway Gen-4.5, AI video generator, filmische AI video, fysica simulatie, Runway AI, WeryAI',
    },
    kling_2_6_pro: {
        title: 'Kling 2.6 Pro AI Video Generator - Hoge Kwaliteit Video Creatie | WeryAI',
        description: 'Genereer hoge kwaliteit video\'s met Kling 2.6 Pro op WeryAI. Native audiovisuele generatie, filmische 1080p kwaliteit, uitstekende prompt naleving.',
        keywords: 'Kling 2.6 Pro, AI video generator, hoge kwaliteit AI video, Kling AI, WeryAI',
    },
    video_dreamina_3: {
        title: 'Dreamina 3.0 Video Generator - Precieze camera controle en frame begeleiding | WeryAI',
        description: 'Genereer filmische AI video\'s met Dreamina 3.0 (Jimeng 3.0) op WeryAI. Precieze start/eind frame controle, professionele camerabewegingen en 1080p hoog-dynamische video generatie.',
        keywords: 'Dreamina 3.0, Jimeng Video 3.0, AI video generator, camera controle, start eind frame, ByteDance AI, WeryAI',
    },
    kling_o1: {
        title: 'Kling O1 AI Video Generator - Creatieve Video Generatie | WeryAI',
        description: 'Laat je creativiteit los op WeryAI met de Kling O1 AI video generator. Perfect voor het genereren van fantasievolle en unieke video-inhoud.',
        keywords: 'Kling O1, AI video generator, creatieve AI video, Kling AI, WeryAI',
    },
}
